import WinPlaceSelectionProcessor from '../../Components/Core/Processors/WinPlaceSelectionProcessor'
import WinPlaceSelectionResultProcessor from '../../Components/Core/SelectionResults/WinPlaceSelectionResultProcessor'
import WinPlaceValidator from '../../Validation/WinPlaceValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class WinPlaceConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'WinPlace',
      name: 'Win & Place',
      supportsFlexi: false,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'winplace-template',
      betSelectionTemplate: 'buttons-selection-template',
      multiBet: false,
      multiSelections: false,
      fieldCheckBoxCount: 1,
      checkBoxCount: 0,
      sameAsCheckBoxCount: 0,
      processor: new WinPlaceSelectionProcessor(),
      validator: new WinPlaceValidator(),
      selectionResultProcessor: new WinPlaceSelectionResultProcessor(),
      legs: 1,
    })
  }
}
